/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto
 */
export interface WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto
     */
    companyUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto
     */
    code?: string | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDtoFromJSON(json: any): WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto {
    return WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyUrl': !exists(json, 'companyUrl') ? undefined : json['companyUrl'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDtoToJSON(value?: WebApiServicesDataTransferObjectsGroupServiceConfirmMemberEmailChangeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyUrl': value.companyUrl,
        'code': value.code,
    };
}

